import { render } from "./detail-setting-api.vue?vue&type=template&id=0fe1c8fe"
import script from "./detail-setting-api.vue?vue&type=script&lang=js"
export * from "./detail-setting-api.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__